<script>
  import SessionDetails from "./reports/SessionDetails.svelte";
  import { _ } from "svelte-i18n";

  export const location = {};
  let storedDays = localStorage.getItem("days");
  let days = storedDays !== null ? JSON.parse(storedDays) : [];

  let storedSessions = localStorage.getItem("sessions");
  let sessions = storedSessions !== null ? JSON.parse(storedSessions) : [];
  let showDayDetails = false;
  let showSessions = false;
</script>

<div class="page-body">
  <div class="content">
    <div class="layout layout--medium">
      <h2 class="layout__title">{$_("statistics.title")}</h2>
      <div class="card">
        <p>{$_("statistics.logged")}</p>
        <span on:click={() => (showDayDetails = !showDayDetails)}
          >{days.length} {$_("statistics.days")}</span
        >
        {$_("statistics.and")}
        <span on:click={() => (showSessions = !showSessions)}
          >{sessions.length} {$_("statistics.sessions")}</span
        >
      </div>
      <h2 class="layout__title">{$_("statistics.log")}</h2>
      <div class="card">
        <div class="input-group input-group--date-picker">
          <label class="input" for="date-from"
            ><span class="input__label">{$_("statistics.from")}</span>
            <div class="DayPicker-wrapper DayPicker-wrapper--calendar-icon">
              <label
                for="57a0c2e1-7c6b-4b6a-843f-0378c77b9b59"
                class="input DayPicker__input"
                ><input
                  type="text"
                  placeholder="Velg dato"
                  value={sessions.length > 0
                    ? sessions
                        .slice()
                        .sort((a, b) =>
                          a.date < b.date ? -1 : a.date > b.date ? 1 : 0
                        )
                        .slice(0, 1)[0].date
                    : new Date().toDateString()}
                  autocomplete="off"
                  class="input__text input__text--size-false"
                  id="57a0c2e1-7c6b-4b6a-843f-0378c77b9b59"
                  mask="11.11.1111"
                  maxlength="10"
                  size="10"
                /></label
              >
            </div></label
          ><label class="input" for="date-to"
            ><span class="input__label">{$_("statistics.to")}</span>
            <div class="DayPicker-wrapper DayPicker-wrapper--calendar-icon">
              <label
                for="57a0c2e1-7c6b-4b6a-843f-0378c77b9b59"
                class="input DayPicker__input"
                ><input
                  type="text"
                  placeholder="Velg dato"
                  value={sessions.length > 0
                    ? sessions
                        .slice()
                        .sort((a, b) =>
                          a.date < b.date ? -1 : a.date > b.date ? 1 : 0
                        )
                        .slice(-1)[0].date
                    : new Date().toISOString()}
                  autocomplete="off"
                  class="input__text input__text--size-false"
                  id="57a0c2e1-7c6b-4b6a-843f-0378c77b9b59"
                  mask="11.11.1111"
                  maxlength="10"
                  size="10"
                /></label
              >
            </div></label
          >
        </div>
        {#each sessions
          .slice()
          .sort( (a, b) => (a.date < b.date ? -1 : a.date > b.date ? 1 : 0) ) as entry}
          <SessionDetails session={entry} />
        {/each}
      </div>
      {#if showDayDetails}
        <div class="card">
          {$_("statistics.days")}:
          <pre style="font-size: 8pt;">{JSON.stringify(days, null, 2)}</pre>
        </div>
      {/if}
      {#if showSessions}
        <div class="card">
          {$_("statistics.sessions")}:
          <pre style="font-size: 8pt;">{JSON.stringify(sessions, null, 2)}</pre>
        </div>
      {/if}
    </div>
  </div>
</div>
